import ReplyComponent from "./Reply";

export default ReplyComponent;
